import { useLoggerEvents } from '@shared-ui/logger-context';
import { LOG_EVENTS } from '../logging/constants';
import { useManager } from '../components';
export var useSignalPublisher = function () {
  var manager = useManager();
  var events = useLoggerEvents(LOG_EVENTS);
  var publishSignal = function (signal) {
    events.SIGNAL_EVENTS_CONTEXT_PUBLISH.log({
      type: signal.type
    });
    manager.publish(signal);
  };
  return {
    publishSignal: publishSignal
  };
};